import { all } from 'redux-saga/effects';

import vivaLeite from './vivaLeite/combineSaga';

export default all([vivaLeite]);
